import type { ElementType, HTMLAttributes, ReactNode } from "react";
import styles from "./Section.module.css";

type Tone = "default" | "soft" | "accent";
type Spacing = "compact" | "default" | "loose";

type SectionProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  tone?: Tone;
  spacing?: Spacing;
  children: ReactNode;
};

export default function Section({
  as: Tag = "section",
  tone = "default",
  spacing = "default",
  className,
  children,
  ...rest
}: SectionProps) {
  const toneClass =
    tone === "soft" ? styles.soft : tone === "accent" ? styles.accent : styles.toneDefault;
  const spacingClass =
    spacing === "compact"
      ? styles.compact
      : spacing === "loose"
        ? styles.loose
        : styles.spacingDefault;

  return (
    <Tag
      className={[styles.section, toneClass, spacingClass, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </Tag>
  );
}
